import { NgModule } from '@angular/core';

import { AdminDashboardService }     from './admin-dashboard.service';
import { ChangeAccountingComponent } from './admin-dashboard.change-accounting.component';
import { SharedModule }              from '../shared/shared.module';
import { TableModule }               from '../table/table.module';
import { WsToWsImportComponent }     from './admin-dashboard.ws-to-ws-import.component';

@NgModule({
  declarations: [
    ChangeAccountingComponent,
    WsToWsImportComponent
  ],
  entryComponents: [
    ChangeAccountingComponent,
    WsToWsImportComponent
  ],
  exports: [
    ChangeAccountingComponent,
    WsToWsImportComponent
  ],
  imports: [
    SharedModule,
    TableModule,
  ],
  providers: [
    AdminDashboardService
  ]
})
export class AdminDashboardModule {}